<div class="modal-header">
  <h3 class="modal-title normal-text center">{{ title | translate }}</h3>
  <button type="button" class="close" (click)="closeClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body">
  <div class="normal-text">
    <p>{{ message | translate }}</p>
  </div>
</div>
<div class="modal-footer justify-content-end">
  <div class="col-12 col-md-4 text-right">
    <button type="button" class="btn btn-primary btn-dialog" (click)="closeClick()">
      {{ 'Close' | translate }}
    </button>
  </div>
</div>
